import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledTh = /*#__PURE__*/styled.th.withConfig({
  componentId: "sc-storm-ui-40025937__sc-x98iyq-0"
})(["background:", ";color:", ";font:", ";padding:", ";border-top:", ";border-bottom:", ";vertical-align:top;text-align:start;", " font-weight:", ";"], ({
  theme
}) => theme.surface.offset, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.table.cell.border.body.default, ({
  theme
}) => theme.table.cell.border.body.default, isMobile(css(["border-bottom:unset;font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme
}) => theme.font.weight.bold);
const KeyCell = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledTh, _extends({
  role: "rowheader",
  scope: "row"
}, rest), children);

export { KeyCell as K };
//# sourceMappingURL=KeyCell-CTp1vrvl.js.map
